export default __webpack_public_path__ + "static/ehv-smooth-silky-acc1032caec4a56c1c1e2c701201d4c7.webp";